import { http } from "./http";
import type { GoingOutState, GoingOutStatus } from "../data/types";

/**
 * Kvällsfrågan.
 *
 * Servern äger både klockan och synligheten. Klienten räknar aldrig ut
 * vilken natt det är, när ett svar går ut eller vem som får se det — den
 * ritar svaret den fick. Se api/goingOut.js.
 */

export function fetchGoingOut() {
  return http.get<GoingOutState>("/going-out");
}

/** Sätter eller ändrar svaret. Returnerar hela det nya tillståndet. */
export function setGoingOut(status: GoingOutStatus) {
  return http.put<GoingOutState>("/going-out", { status });
}
